import React from 'react';

function ErrorMessage({ error }) {
  return (
    <div className="error-container">
      <div className="error-icon">⚠️</div>
      <p className="error-text">Failed to load layers</p>
      <p className="error-details">{error}</p>
    </div>
  );
}

export default ErrorMessage;
